__turbopack_context__.v({
  "beacon": "OnboardingEditorMenu-module-scss-module__tHA2la__beacon",
  "help-button": "OnboardingEditorMenu-module-scss-module__tHA2la__help-button",
  "help-button-container": "OnboardingEditorMenu-module-scss-module__tHA2la__help-button-container",
  "icon-container": "OnboardingEditorMenu-module-scss-module__tHA2la__icon-container",
});
